import { TypedRootState } from '../types';

export const selectSampleFileName = (state: TypedRootState) => state.sampleFileName;
